export function insertSvgPagination() {
    let svg = "<svg width=\"18\" height=\"17\" viewBox=\"0 0 18 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
        "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.9121 8.5L0.895251 16.939L5.55272 8.50146L0.895252 0.0610213L17.9121 8.5Z\" fill=\"#003CA5\"/>\n" +
        "</svg>\n";
    let pagination = $('.pagination');
    let linkPrev = pagination.find('.previouspostslink');
    let linkNext = pagination.find('.nextpostslink');
    if (linkPrev) {
        linkPrev.append(svg);
    }
    if (linkNext) {
        linkNext.append(svg);
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/insertSvgPagination.js